import type { ReactElement, ReactNode } from 'react';
import { cloneElement } from 'react';
import { useDangerConfirm } from '../../hooks/useDangerConfirm';

export interface ConfirmActionProps {
  title: ReactNode;
  description?: ReactNode;
  irreversibleHint?: boolean;
  tone?: 'danger' | 'primary';
  okText?: string;
  cancelText?: string;
  onConfirm: () => void | Promise<void>;
  children: ReactElement;
  disabled?: boolean;
}

export default function ConfirmAction({
  title,
  description,
  irreversibleHint,
  tone = 'danger',
  okText,
  cancelText,
  onConfirm,
  children,
  disabled,
}: ConfirmActionProps) {
  const confirm = useDangerConfirm();
  return cloneElement(children as any, {
    onClick: (event: any) => {
      (children as any).props?.onClick?.(event);
      if (disabled || event?.defaultPrevented) return;
      confirm({
        title,
        description,
        irreversibleHint,
        tone,
        okText,
        cancelText,
        onOk: onConfirm,
      });
    },
  });
}
